<template lang="html">
  <div class="neutral">
    <div class="ui padded grid h-100 login-page">
      <div
        class="seven wide computer sixteen wide mobile column h-100 first-tab"
      >
        <div class="ui centered grid h-100">
          <div
            class="ten wide computer sixteen wide mobile column h-100 main-form"
          >
            <div v-show="loading" class="ui active inverted dimmer">
              <div class="ui text loader">Entrando</div>
            </div>
            <!-- <ResetPassword ref="resetPassword" v-show="showResetPassword" /> -->
            <form
              @submit.prevent="signin"
              class="ui form login-form"
              v-show="!showResetPassword"
            >
              <div class="field">
                <label for="signin-login">Usuário</label>
                <input
                  id="signin-login"
                  name="username"
                  type="text"
                  placeholder="Digite seu usuário"
                  v-model="credentials.login"
                />
              </div>

              <div class="field">
                <label for="signin-password">Senha</label>
                <input
                  id="signin-password"
                  type="password"
                  placeholder="Senha"
                  v-model="credentials.password"
                />
              </div>

              <p class="text-right">
                <a @click.prevent="toggleShowResetPassword"
                  >Esqueci minha senha</a
                >
              </p>

              <button
                class="ui fluid primary small button"
                :disabled="loading"
                type="submit"
              >
                Entrar
              </button>

              <!-- <img alt="Logo" class="ui centered image naja-logo" src="@/assets/logo.png"> -->
            </form>
          </div>
        </div>
      </div>
      <div class="nine wide computer only column h-100 custom-client-bg">
        <div class="ui centered grid h-100">
          <div class="ten wide column content">
            <div>
              <h1 class="ui header">ClubOn</h1>
              <p class="description">
                A maneira mais simples de gerenciar assinaturas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/resources/Api';
// import ResetPassword from './widgets/reset_password.vue'
import { mapState } from 'vuex';

export default {
  name: 'login',
  // components: { ResetPassword },
  computed: {
    ...mapState({
      rule: state => state.user.user.rule
    })
  },

  data() {
    return {
      loading: false,
      showResetPassword: false,
      credentials: {
        login: '',
        password: ''
      }
    };
  },

  methods: {
    toggleShowResetPassword() {
      // this.showResetPassword = !this.showResetPassword
      // if(this.showResetPassword) {
      //   this.$refs.resetPassword.focus()
      // }
    },

    signin() {
      this.loading = true;
      Api.authenticate(this.credentials)
        .then(async response => {
          this.$store.commit('user/updateUser', {
            token: response.data.auth_token
          });
          await this.$store.dispatch('user/getUserInfo');
          await this.$store.dispatch('settings/getSettings');

          if (this.rule == 'partner') {
            this.$router.push({ name: 'partner' });
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(e => {
          this.$toast.show('Login inválido', 'error');
          throw e;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="css" scoped>
.first-tab {
  background: white;
}

.main-form {
  display: flex !important;
  align-items: center;
}

.centered.grid {
  font-size: 1.28rem;
}

.ui.form .field {
  clear: both;
  margin: 0em 0em 2em;
}

.custom-client-bg {
  background: #2b3137;
  padding: 0px !important;
  overflow: overflow;
}

.custom-client-bg .content {
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: white;
}

.custom-client-bg .content .ui.header {
  color: white;
}

.custom-client-bg .content .description {
  color: rgba(255, 255, 255, 0.6);
}

.client-logo {
  max-height: 5.714rem;
  margin-bottom: 3rem;
}

.login-form {
  margin-top: 0px;
  padding: 0px 1rem;
  width: 100%;
}

.login-form button {
  min-height: 3rem;
  font-size: 1.28rem;
  text-transform: uppercase;
  font-weight: bold;
}

.naja-logo {
  height: 3rem;
  margin-top: 2rem;
}
</style>
